class RecallCommunicationItem {
    public Id: string;
    public Notes: string;
    public DateCreated: string;
    public State: string;
    public Employee: string;
}

export { RecallCommunicationItem };
